<router-outlet></router-outlet>
<ng-http-loader
    [entryComponent]="spinner"
    [filteredHeaders]="['ngLoader']"
    [backgroundColor]="'#0070b7'"
    [debounceDelay]="0"
    [extraDuration]="0"
    [minDuration]="0">
</ng-http-loader>
